(() => {
  try {
    const getCurrentPWS = async () => {
      const urlParams = new URLSearchParams(window.location.search);

      const fallbackPWS = sessionStorage.getItem("404_PATH")?.split("/")?.at(1);
      sessionStorage.removeItem("404_PATH");
      if (fallbackPWS?.length) {
        return fallbackPWS;
      }

      // Resolve PWS from ?show= URL param.
      // We attribute to the show's stylist (PWS) but do NOT capture any show
      // context (no CURRENT_SHOW_* localStorage, no show data on the order).
      const showIdFromUrl = urlParams.get("show");
      if (showIdFromUrl && window.backend) {
        const showPartner = await window.backend.getPartnerByShowId(showIdFromUrl);
        if (showPartner?.siteName?.length) {
          return showPartner.siteName;
        }
      }

      const paramPWS = urlParams.get("pws");
      if (paramPWS) return paramPWS;

      // Fallback: check referrer URL for pws param
      try {
        const referrerUrl = document.referrer || sessionStorage.getItem("TRACKING_REFERRER");
        if (referrerUrl) {
          const referrerParams = new URL(referrerUrl).searchParams;
          const referrerPWS = referrerParams.get("pws");
          if (referrerPWS) return referrerPWS;
        }
      } catch (e) {
        // referrer URL may be invalid or cross-origin, ignore
      }

      const localPWS = localStorage.getItem("CURRENT_SITE");
      if (localPWS) return localPWS;

      return null;
    };

    const getPreferredPWS = async () => {
      const sessionPWS = sessionStorage.getItem("PREFERRED_SITE");
      if (sessionPWS) return sessionPWS;

      const preferredStylistId = window?.customer?.preferredStylistId;
      if (preferredStylistId && window.backend) {
        const partner = await window.backend.getPartnerByStylistId(preferredStylistId);
        if (partner?.siteName?.length) {
          return partner.siteName;
        }
      }

      return null;
    };

    const loadTrackingInfo = () => {
      if (!sessionStorage.getItem("TRACKING_LANDING_URL")) {
        sessionStorage.setItem("TRACKING_LANDING_URL", window.location.href);
      }

      if (!sessionStorage.getItem("TRACKING_REFERRER") && document.referrer) {
        sessionStorage.setItem("TRACKING_REFERRER", document.referrer);
      }
    };

    function updateUrlPWS(pws) {
      const urlParams = new URLSearchParams(window.location.search);
      urlParams.set("pws", pws);

      // Preserve the hash value if it exists
      const hashValue = window.location.hash;

      // Update URL while maintaining the hash
      window.history.replaceState({}, "", window.location.pathname + "?" + urlParams.toString() + hashValue);
    }

    async function handlePWSMismatch(currentPWS, preferredPWS) {
      if (!window.backend) {
        console.error('[Attribution] Cannot handle PWS mismatch - window.backend not available');
        return;
      }

      const [currentPartner, preferredPartner] = await Promise.all([
        window.backend.getPartnerBySite(currentPWS),
        window.backend.getPartnerBySite(preferredPWS),
      ]);

      if (!(currentPartner && preferredPartner)) {
        return;
      }
      document.dispatchEvent(
        new CustomEvent("theme:partner:mismatch", {
          detail: { current: currentPartner, preferred: preferredPartner },
        })
      );
    }

    async function handlePartnerResolution(currentPWS, preferredPWS) {
      if (!window.backend) {
        console.error('[Attribution] Cannot resolve partner - window.backend not available');
        return;
      }

      const currentOrPreferredPWS = currentPWS || preferredPWS;
      if (!currentOrPreferredPWS) {
        return;
      }

      const partner = await window.backend.getPartnerBySite(
        currentOrPreferredPWS
      );

      if (!partner?.siteName?.length) {
        return;
      }

      if (
        window?.customer &&
        window.customer?.customerType !== "Stylist" &&
        window.customer?.preferredStylistId === null
      ) {
        window.backend.syncPreferredStylist(partner.siteName);
        window.customer.preferredStylistId = partner?.stylistId;
      }

      updateUrlPWS(partner.siteName);

      localStorage.setItem("CURRENT_SITE", partner.siteName);
      localStorage.setItem("CURRENT_STYLIST_ID", partner.stylistId);
      sessionStorage.setItem("PREFERRED_SITE", partner.siteName);

      window.partner = partner;
      // Disable affinity update
      // document.dispatchEvent(
      //   new CustomEvent("theme:partner:update", { detail: { partner } })
      // );

      document.dispatchEvent(new CustomEvent("theme:partner:render", { detail: { partner } }));
    }

    document.addEventListener("DOMContentLoaded", async () => {
      // Defensive check: Ensure backend API is available
      if (!window.backend) {
        console.error('[Attribution] window.backend is not available. Backend.js may not be loaded yet.');
        return;
      }

      loadTrackingInfo();
      const currentPWS = await getCurrentPWS();
      const preferredPWS = await getPreferredPWS();

      if (window?.customer && window.customer?.isStylist) {
        updateUrlPWS(window.customer.siteName);
        localStorage.setItem("CURRENT_SITE", window.customer.siteName);
        localStorage.setItem("CURRENT_STYLIST_ID", window.customer?.stylistId ?? "NONE");
        await handlePartnerResolution(
          window.customer.siteName,
          window.customer.siteName
        );
      } else {
        const isDifferentPWS = currentPWS && preferredPWS && currentPWS !== preferredPWS;

        if (isDifferentPWS) {
          await handlePWSMismatch(currentPWS, preferredPWS);
        } else {
          await handlePartnerResolution(currentPWS, preferredPWS);
          //TODO: should be this triiger when the partner is null and the variable pws exists?
          if (window.partner !== null && window.partner?.status === "Former") {
            document.dispatchEvent(
              new CustomEvent("theme:partner:unavailable", {
                detail: { partner: window.partner },
              })
            );
          }
        }
      }
    });
  } catch (e) {
    console.error(e);
  }
})();
